/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1DocumentCourseDocuments201,
  PostApiV1DocumentCourseDocuments400,
  PostApiV1DocumentCourseDocuments401,
  PostApiV1DocumentCourseDocuments404,
  PostApiV1DocumentCourseDocuments500,
  PostApiV1DocumentCourseDocumentsMutationRequest,
  PostApiV1DocumentCourseDocumentsMutationResponse,
} from "../../types/documentCourseDocumentsController/PostApiV1DocumentCourseDocuments.ts";
import { courseDocumentsDetailViewModelSchema } from "../courseDocumentsDetailViewModelSchema.ts";
import { courseDocumentsEditorViewModelSchema } from "../courseDocumentsEditorViewModelSchema.ts";

/**
 * @description (Created) Objeto criado com sucesso.
 */
export const postApiV1DocumentCourseDocuments201Schema = z.lazy(
  () => courseDocumentsDetailViewModelSchema,
) as unknown as ToZod<PostApiV1DocumentCourseDocuments201>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1DocumentCourseDocuments400Schema =
  z.any() as unknown as ToZod<PostApiV1DocumentCourseDocuments400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1DocumentCourseDocuments401Schema =
  z.any() as unknown as ToZod<PostApiV1DocumentCourseDocuments401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1DocumentCourseDocuments404Schema =
  z.any() as unknown as ToZod<PostApiV1DocumentCourseDocuments404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1DocumentCourseDocuments500Schema =
  z.any() as unknown as ToZod<PostApiV1DocumentCourseDocuments500>;

export const postApiV1DocumentCourseDocumentsMutationRequestSchema = z.lazy(
  () => courseDocumentsEditorViewModelSchema,
) as unknown as ToZod<PostApiV1DocumentCourseDocumentsMutationRequest>;

export const postApiV1DocumentCourseDocumentsMutationResponseSchema = z.lazy(
  () => postApiV1DocumentCourseDocuments201Schema,
) as unknown as ToZod<PostApiV1DocumentCourseDocumentsMutationResponse>;
